// Bound historical API traffic without occupying browser connection slots while
// waiting. Active tasks receive their original AbortSignal via the caller.
export const createRequestQueue = (limit) => {
    let active = 0;
    const waiting = [];
    const pump = () => {
        while (active < limit && waiting.length) {
            const job = waiting.shift();
            job.signal?.removeEventListener('abort', job.abort);
            active += 1;
            Promise.resolve().then(() => {
                if (job.signal?.aborted) throw new DOMException('Request cancelled', 'AbortError');
                return job.task();
            }).then(job.resolve, job.reject).finally(() => { active -= 1; pump(); });
        }
    };
    return (task, signal) => new Promise((resolve, reject) => {
        if (signal?.aborted) {
            reject(new DOMException('Request cancelled', 'AbortError'));
            return;
        }
        const job = { task, signal, resolve, reject };
        job.abort = () => {
            const index = waiting.indexOf(job);
            if (index !== -1) waiting.splice(index, 1);
            reject(new DOMException('Request cancelled', 'AbortError'));
        };
        signal?.addEventListener('abort', job.abort, { once: true });
        waiting.push(job);
        pump();
    });
};
